import {Component} from '@angular/core';
import {AngularFireAuth} from 'angularfire2/auth';
import {environment} from '../../../environments/environment';

@Component({
  selector: '[menu]',
  templateUrl: './menu.component.html'
})
export class MenuComponent {
  analyticsUrl: string = environment.analyticsUrl;
  constructor(private af: AngularFireAuth) {}

  logout() {
    this.af.auth.signOut();
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/layouts/menu/menu.component.ts